import React, { useState } from 'react';

const About = ({ aboutText }) => {
  const showMoreText = ' ...more';
  const showLessText = ' ...less';
  const INITIAL_CHARS_TO_SHOW = 200;

  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      {aboutText && aboutText.length > 5 && (
        <div className="py-2">
          <p className="text-sm text-gray-700 text-justify">
            {isExpanded ? aboutText : `${aboutText.slice(0, INITIAL_CHARS_TO_SHOW)}`}
            {!isExpanded && aboutText.length > INITIAL_CHARS_TO_SHOW && (
              <span onClick={handleToggle} className="text-blue-500 cursor-pointer">{showMoreText}</span>
            )}
            {isExpanded && (
              <span onClick={handleToggle} className="text-blue-500 cursor-pointer">{showLessText}</span>
            )}
          </p>
        </div>
      )}
    </>
  );
};

export default React.memo(About);
